module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/m0-ac1e5d9182b9e47c41b9c43c8fe0ede3.svg";